<template>
  <div class="workout-row" v-if="workout && workoutSet">
    <div class="cell station">{{ station.name }}</div>
    <div class="cell sets">{{ workout.sets.length }}</div>
    <div class="cell weight">
      <input type="number" v-model="workoutSet.weight" />
    </div>
    <div class="cell rep">
      <input type="number" v-model="workoutSet.reps" />
    </div>
    <div class="cell actions">
      <button @click="addWorkoutSet">OK</button> &nbsp;
      <button @click="removeLatestWorkoutSet" v-if="workout.sets.length > 0">
        DEL
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkoutRow",
  props: {
    station: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      workout: null,
      workoutSet: null
    };
  },
  created() {
    this.workout = this.$storage.provideWorkout(
      this.station.id,
      this.timestampNow()
    );
    this.workoutSet = this.nextWorkoutSet();
  },
  computed: {},
  methods: {
    timestampNow() {
      const date = new Date();
      date.setMilliseconds(0);
      date.setSeconds(0);
      date.setMinutes(0);
      date.setHours(0);
      return date.getTime();
    },
    nextWorkoutSet() {
      let latestWorkout = this.$storage.getLatestWorkout(this.station.id);
      return { ...latestWorkout.sets[latestWorkout.sets.length - 1] };
    },
    addWorkoutSet() {
      this.workout.sets.push(this.workoutSet);
      this.workoutSet = this.nextWorkoutSet();
      this.$storage.save();
      this.$forceUpdate();
    },
    removeLatestWorkoutSet() {
      this.workout.sets.splice(this.workout.sets.length - 1);
      this.$storage.save();
    }
  }
};
</script>

<style scoped></style>
